


import "./index.less";

const prefix ="message-layout"

interface MessageLayoutProps {
  menus?: any[]
  activeMenuKey?: string
  menuClick?: (data: any) => void
  children?: any
  title:string
}

/**
 * 消息中心布局组件 适用于：消息中心、费用中心
 * @param props 
 * @returns 
 */
const MessageLayout = (props: MessageLayoutProps) => {
  const {menus,title="",activeMenuKey,menuClick=()=>{console.log(1)},children=<></>} = props;
  return  <>
    <div className="message-layout message-box">
      <div className={`${prefix}-aside`}>
        <div className={`${prefix}-aside-title`}>{title}</div>
        <div className={`${prefix}-aside-menu`}>
          {
            menus?.map((item, index) => {
              return <div 
                className={`${prefix}-aside-menu-item ${activeMenuKey==item?.key ? 'menu-active' : ''}`} 
                key={item?.key}
                onClick={() => {
                  menuClick(item);
                  }
                }
              >
                {item?.label}
              </div>
            })
          }
        </div>
      </div>
      <div className={`${prefix}-main`}>
          {children}
      </div>    
    </div>
  
  </>
}

export default MessageLayout